const SIZES = {
  'vehicles[q]': 3,
  'vehicles[vehicle_brand_id]': 2,
};

export default SIZES;
